const addListener = function(el, type, fn) {
  el.addEventListener(type, fn, false)
}
//去掉空格
const spaceFilter = function(el) {
  addListener(el, 'input', () => {
    el.value = el.value.replace(/\s+/, '')
  })
}
// 防抖
let debounce = (fn, delay) => {
  var delays = delay || 100;
  var timer;
  return function() {
    var th = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      timer = null;
      fn.apply(th, args);
    }, delays);
  };
}
// 限制只能输入整数和小数（价格类、两位小数）
const priceFilter = function(el) {
  addListener(el, 'input', debounce(() => {//添加防抖 防止反复触发事件导致内存溢出
    el.value = (el.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
    if (isNaN(el.value)) {
      el.value = ''
    }
    //触发input事件
    el.dispatchEvent(new Event('input'))
  }))
}

// 限制只能输入英文数字 英文符号 - _
const snFilter = function(el) {
  addListener(el, 'input', debounce(() => {//添加防抖 防止反复触发事件导致内存溢出
    el.value = el.value.match(/^[^\u4e00-\u9fa5\s]*$/gi) || '' 
    //触发input事件
    el.dispatchEvent(new Event('input'))
  }))
}
// 限制整数
const snInt = function(el) {
  addListener(el, 'input', debounce(() => {//添加防抖 防止反复触发事件导致内存溢出
    el.value = (el.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
    if (isNaN(el.value)) {
      el.value = ''
    }else{
      el.value=Math.ceil(el.value)
    }
    //触发input事件
    el.dispatchEvent(new Event('input'))
  }))
}
// 去除特殊符号
const excludeSpecial=function(el){
  addListener(el, 'input', debounce(() => {//添加防抖 防止反复触发事件导致内存溢出
    var patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im; 
    el.value=el.value.replace(patrn,'')
    if (patrn.test(el.value)) {// 如果包含特殊字符返回false
      el.value=null
    }
    //触发input事件
    el.dispatchEvent(new Event('input'))
  }))
}
//最大经验值
const maxExp = function(el,binding){
  addListener(el, 'input', debounce(() => {
      if(el.value<=binding.value.max){
        el.value = parseInt(el.value) || 0;
      }else{
         el.value = binding.value.max;
      }
      el.dispatchEvent(new Event('input'))
  }))
}

//手机号
const phone = function(el){
  addListener(el, 'input', debounce(() => {
    el.value=el.value.replace(/\D/g,'')
    el.dispatchEvent(new Event('input'))
}))
}


export default {
  mounted(el, binding) {
    if (el.tagName.toLowerCase() !== 'input') {
      el = el.getElementsByTagName('input')[0]
    }
    spaceFilter(el)
    switch (binding.arg) {
      case 'price':
        priceFilter(el)
        break;
      case 'sn':
        snFilter(el)
        break;
        case 'Int':
          snInt(el)
        break;
        case 'excludeSpecial':
          excludeSpecial(el)
        break;
        case 'maxExp':
          maxExp(el,binding)
        break
        case 'phone':
        phone(el);
        break;
      default:
        console.warn('未知指令类型',binding.arg)
        break
    }
  }
}